export default "__VITE_ASSET__16359897__"